import { useQuery } from '@tanstack/react-query'

import { fetchNoticeReadStatus } from '@/lib/venue/campaignPerformanceApi'

export function noticeReadStatusQueryKey(venueId: string, params: { from: string; to: string }) {
  return ['venue', venueId, 'notice-read-status', params] as const
}

/** 운영 공지 열람 현황 탭(#734 §1-5) — 비용·전환 지표와 분리된 별도 EP. */
export function useNoticeReadStatus(
  venueId: string,
  params: { from: string; to: string },
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: noticeReadStatusQueryKey(venueId, params),
    queryFn: () => fetchNoticeReadStatus(venueId, params),
    enabled: options.enabled ?? true,
  })
}
